import { render, staticRenderFns } from "./DeleteQuestionDialog.vue?vue&type=template&id=7805c08d&"
import script from "./DeleteQuestionDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteQuestionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports